export default "__VITE_ASSET__CqGQOCQN__"